import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { failedResponse, getBackendUrl, loaded, loading, error, LoadStateInfo, notStarted } from "../common";
import { getToken } from "../../features/user/UserAvatar";
import { RootState } from "../../app/store";
import { MessagePriority } from "./messagePriority";
import { MessageType } from "./messageListSlice";

export interface ObjectTargetId {
    objectTargetId: string;
    targetId: string;
}

export interface MessageSendMassiveRequest {
    text: string;
    targets: ObjectTargetId[];
    messagePriority: MessagePriority;
    messageType: MessageType;
    filename?: string;
}

export const performMessageSendMassive = createAsyncThunk(
    "performMessageSendMassive",
    async (param: MessageSendMassiveRequest, thunkAPI) => {
        console.debug("send message");

        const response = await fetch(`${getBackendUrl()}/api/conversation/message/massive`, {
            method: "POST",
            signal: thunkAPI.signal,
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${getToken()}`,
            },
            body: JSON.stringify(param),
        });

        if (response.ok) {
            return "ok";
        } else {
            return thunkAPI.rejectWithValue(failedResponse(response));
        }
    }
);

export interface MessageSendMassiveState {
    state: LoadStateInfo;
    request?: MessageSendMassiveRequest;
}

const initialState: MessageSendMassiveState = {
    state: notStarted(),
};

export const messageSendMassiveSlice = createSlice({
    name: "messageSendMassive",
    initialState,
    reducers: {
        clean: (state) => {
            state.state = notStarted();
            state.request = undefined;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(performMessageSendMassive.pending, (state, action) => {
                state.state = loading();
                state.request = action.meta.arg;
            })
            .addCase(performMessageSendMassive.fulfilled, (state, action) => {
                console.debug(`${action.type}`);
                state.state = loaded();
            })
            .addCase(performMessageSendMassive.rejected, (state, action) => {
                state.state = error(action);
            });
    },
});

// export const { } = messageSendMassiveSlice.actions;

export const selectMessageSendMassive = (state: RootState) => state.messageSendMassive;

export default messageSendMassiveSlice.reducer;
